<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary"
                        (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ 'goalsValidation.subordinatesGoalsValidation' | translate }}
            </ion-label>
        </ion-item>

        <ion-card mode="ios" class="team-card">
            <ion-card-header color="">
                <ion-card-title color="primary">
                    {{ 'goalsValidation.yourTeam' | translate }}
                </ion-card-title>
                <ion-searchbar mode="ios"
                               class="section-search-custom"
                               [placeholder]="'generic.searchByName' | translate"
                               (keyup)="updateSearch($any($event).target.value)"
                ></ion-searchbar>
            </ion-card-header>
            <ion-card-content class="ion-no-padding">
                <ion-grid class="team">
                    <ion-row class="header">
                        <ion-col offset-sm="2" offset-lg="1">
                            {{ 'generic.evaluee' | translate }}
                        </ion-col>
                    </ion-row>
                    <ion-row *ngFor="let goal of displayedGoals">
                        <ion-col size="2" size-lg="1">
                            <img [src]="getImageUrl(goal.imageUrl)" default="" class="avatar">
                        </ion-col>
                        <ion-col class="ion-align-self-center">
                            <h3>{{ goal.name }}</h3>
                        </ion-col>
                        <ion-col size="4" size-lg="3" [ngSwitch]="goal.status" flexed>
                            <ion-button class="ion-text-wrap" mode="ios" expand="block"
                                        *ngSwitchCase="SubordinateGoalStatus.WaitingValidation"
                                        [color]="getStatusColor(goal.status)"
                                        (click)="goToValidation(goal)">
                                {{ 'generic.validate' | translate }}
                            </ion-button>
                            <ion-button class="ion-text-wrap" mode="ios"
                                        *ngSwitchCase="SubordinateGoalStatus.WaitingChanges"
                                        color="warning" fill="clear" expand="block">
                                {{ 'generic.waitingChanges' | translate }}
                                <ion-icon slot="end" class="bp-clock"></ion-icon>
                            </ion-button>
                            <ion-button class="ion-text-wrap" mode="ios"
                                        *ngSwitchCase="SubordinateGoalStatus.Pending"
                                        color="warning" fill="clear" expand="block">
                                {{ 'generic.waitingInput' | translate }}
                                <ion-icon slot="end" class="bp-clock"></ion-icon>
                            </ion-button>
                            <ng-container *ngSwitchCase="SubordinateGoalStatus.Validated">
                                <ion-button class="ion-text-wrap" mode="ios"
                                            color="success" fill="clear" expand="block">
                                    {{ 'generic.validated' | translate }}
                                    <ion-icon slot="end" class="bp-check"></ion-icon>
                                </ion-button>
                                <a *ngIf="!goal.hasConsentAttributes || forcedManagerInclusion" (click)="goToValidation(goal)" style="cursor: pointer; text-decoration: underline; margin-right: 10px;">
                                    {{ 'dashboard.See' | translate }}
                                </a>
                                <ion-button *ngIf="isAllowedToReopen && !goal.hasConsentAttributes && !forcedManagerInclusion" class="ion-text-wrap" mode="ios" expand="block" color="primary"
                                            (click)="reopenValidation(goal)">
                                    {{ 'processParticipants.reopen' | translate }}
                                </ion-button>
                            </ng-container>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>
    </div>
</ion-content>